import { Divider, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { DataTitle } from '../../DataTitle';
import { useDictionary, useIsDesktop } from 'Hooks';
import { IPostOfficeAddress } from '..';

interface IPostOffice {
  postOfficeAddress: IPostOfficeAddress | null;
}

export const PostOffice = ({ postOfficeAddress }: IPostOffice) => {
  const dict = useDictionary(Dictionary, DICTIONARY.PersonalDetails)
    .addressInformation.postOffice;

  const isDesktop = useIsDesktop();

  const dataTitles = [
    { title: dict.town, data: postOfficeAddress?.postOffice },
    { title: dict.zipCode, data: postOfficeAddress?.zipCode },
  ];

  return (
    <Stack gap={'20px'}>
      <Typography variant={'body6'}>{dict.title}</Typography>
      <Stack
        direction={'row'}
        gap={isDesktop ? '40px' : '20px 10px'}
        flexWrap={'wrap'}
      >
        {dataTitles.map((dataTitle, index) => (
          <Stack width={'136px'} key={index}>
            <DataTitle dataTitle={dataTitle.title} data={dataTitle.data} />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
